import React from 'react'
import PropTypes from 'prop-types'
import './style.css'

const BannerList = (props) => {
    return (
        <div className='slide-list'>
            {props.children}
        </div>
    )
}

BannerList.propTypes = {}

export default BannerList




// WEBPACK FOOTER //
// ./src/components/_admin/BannerList/index.js